$(document).on("click", "[data-tab-target]", function() {
  var target = $(this).data("tab-target");

  $("[data-tab-target]").removeClass("active");
  $("[data-content-target]").removeClass("active");

  $(this).addClass("active");

  $("[data-content-target='" + target + "']").addClass("active");
});


$(document).ready(function() {
  $(document).on("click", "[data-tab-target]", function() {
    var target = $(this).data("tab-target");

    $("[data-tab-target]").removeClass("active");
    $("[data-content-target]").removeClass("active");

    $(this).addClass("active");
    $("[data-content-target='" + target + "']").addClass("active");
  });

  function toggleOpenByWidth() {
    if ($(window).width() >= 750) {
      $("[data-content-target]").attr("open", true);
    } else {
      $("[data-content-target]").removeAttr("open");
    }
  }

  toggleOpenByWidth();

  var lastWidth = $(window).width();
  $(window).on("resize", function() {
    var newWidth = $(window).width();
    if (newWidth !== lastWidth) {
      lastWidth = newWidth;
      toggleOpenByWidth();
    }
  });
});

$(document).ready(function(){
  function setupTitleObserver($title) {
    if (!$title.length) return;

    function forceTitle() {
      if ($title.text() !== "COMMENT") {
        $title.text("COMMENT");
      }
    }

    forceTitle();

    var observer = new MutationObserver(forceTitle);
    observer.observe($title[0], {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function checkAndObserve() {
    var $title = $(".jdgm-rev-widg__title");
    if ($title.length) {
      setupTitleObserver($title);
      return true;
    }
    return false;
  }

  if (!checkAndObserve()) {
    var bodyObserver = new MutationObserver(function(){
      if (checkAndObserve()) {
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
});

